/** Positionierung, Höhe und Safe-Areas jeder Detail-Sidebar (Etappe E3a).
 *  Unter `md` volle Breite — auf 390 px hat kein 420-px-Panel Platz, es lief
 *  bisher 30 px über den Rand hinaus. Ab `md` bekommt jede Sidebar ihre eigene
 *  feste Spaltenbreite (`md:w-[…]`) selbst mit — die vier unterscheiden sich
 *  (420 px bei Zähler/Vertrag, 500/560 px bei Rechnung). Deshalb steht hier
 *  bewusst keine Breitenvorgabe ab `md`: zwei gleich spezifische `md:w-*`-Klassen
 *  auf demselben Element ließen die Reihenfolge im generierten Stylesheet
 *  entscheiden, statt dass die Absicht im Code sichtbar wird.
 *  Safe-Areas auf allen vier Seiten: im Querformat liegt die Notch seitlich.
 *  Farbwelt, Schatten und Rahmen bleiben Sache der jeweiligen Sidebar. */
export const DETAIL_FLAECHE =
  'fixed top-0 right-0 z-[200] h-screen w-full flex flex-col '
  + 'pt-[env(safe-area-inset-top)] pb-[env(safe-area-inset-bottom)] '
  + 'pl-[env(safe-area-inset-left)] pr-[env(safe-area-inset-right)]';
